import React, { Component } from "react";
import { Spin, Modal, Row, Col, Button, Descriptions, Pagination } from "antd";
import { history } from "../../../helpers";
import MetricsView from "./MetricsView";

import { getClinicList } from "../../../services";

export default class MetricsContainer extends Component {
  render() {
    const { details } = this.props;

    return <>{details && <MetricsView details={details} />}</>;
  }
}
